<template functional>
  <i class="fas fa-exclamation-triangle red fs15" v-if="props.item.haz_cargo" />
</template>

<script>
export default {
  name: "drayage-haz",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
